import { render } from "./LendRecord.vue?vue&type=template&id=1cfb85da"
import script from "./LendRecord.vue?vue&type=script&lang=js"
export * from "./LendRecord.vue?vue&type=script&lang=js"

import exportComponent from "E:\\学习资料\\项目\\Vue-Springboot-Library-main\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__